import React from 'react';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer className="border-t" style={{ borderColor: 'rgba(168,169,173,0.1)', background: '#0a0a0b' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <Image
                src="/assets/images/ChatGPT_Image_May_22_2026_01_33_45_AM-1779432418643.png"
                alt="Lotus Line Detailing Logo"
                width={48}
                height={48}
                className="rounded-full object-cover"
                style={{ border: '1px solid rgba(212,212,216,0.15)' }}
              />
              <div>
                <span className="text-base font-bold" style={{ color: '#F5F5F7' }}>Lotus Line Detailing</span>
                <p className="mono text-[9px] tracking-widest uppercase mt-0.5" style={{ color: 'rgba(168,169,173,0.45)' }}>
                  Mobile · Premium · Professional
                </p>
              </div>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(168,169,173,0.55)' }}>
              Fully mobile detailing service. We come to your home, apartment, or workplace — bringing professional-grade equipment and products to you.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-3">
            <p className="mono text-[9px] tracking-widest uppercase mb-1" style={{ color: 'rgba(168,169,173,0.35)' }}>Navigation</p>
            {['Services', 'Pricing', 'FAQ', 'Contact']?.map((link) => (
              <a
                key={link}
                href={`#${link?.toLowerCase()}`}
                className="mono text-[11px] font-medium tracking-widest uppercase transition-colors duration-200 w-fit"
                style={{ color: 'rgba(168,169,173,0.6)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.6)')}
              >
                {link}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-3">
            <p className="mono text-[9px] tracking-widest uppercase mb-1" style={{ color: 'rgba(168,169,173,0.35)' }}>Contact</p>
            <a
              href="tel:+13313566014"
              className="flex items-center gap-2 text-sm transition-colors"
              style={{ color: 'rgba(168,169,173,0.7)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.7)')}
            >
              <Icon name="PhoneIcon" size={14} variant="outline" />
              331-356-6014
            </a>
            <a
              href="tel:+18478493854"
              className="flex items-center gap-2 text-sm transition-colors"
              style={{ color: 'rgba(168,169,173,0.7)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.7)')}
            >
              <Icon name="PhoneIcon" size={14} variant="outline" />
              847-849-3854
            </a>
            <a
              href="https://instagram.com/lotuslinedetailing"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm transition-colors"
              style={{ color: 'rgba(168,169,173,0.7)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.7)')}
            >
              <Icon name="CameraIcon" size={14} variant="outline" />
              @lotuslinedetailing
            </a>
            <p className="text-sm" style={{ color: 'rgba(168,169,173,0.55)' }}>
              Service Area: Chicagoland & Surrounding Areas
            </p>
          </div>
        </div>

        <div className="border-t pt-6 flex flex-col md:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(168,169,173,0.08)' }}>
          <span className="mono text-[10px]" style={{ color: 'rgba(168,169,173,0.3)' }}>
            © 2026 Lotus Line Detailing · All Rights Reserved
          </span>
          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/lotuslinedetailing"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors"
              style={{ color: 'rgba(168,169,173,0.4)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.4)')}
              aria-label="Instagram"
            >
              <Icon name="CameraIcon" size={16} variant="outline" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}